// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".predicty--WbIf_ {\n  object-fit: contain;\n}", "",{"version":3,"sources":["webpack://./src/gui/Components/Icons/ChatBot/Predicty/index.module.scss"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB","sourcesContent":[".predicty {\n  object-fit: contain;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"predicty": "predicty--WbIf_"
};
export default ___CSS_LOADER_EXPORT___;
